import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface QuickActionButtonProps {
  icon: ReactNode;
  label: string;
  onClick?: () => void;
}

const QuickActionButton = ({ icon, label, onClick }: QuickActionButtonProps) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 2,
        borderRadius: '8px',
        bgcolor: 'transparent',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: '1px solid #E5E7EB',
        '&:hover': {
          bgcolor: '#F9FAFB',
          borderColor: '#D1D5DB'
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 40,
          height: 40,
          borderRadius: '8px',
          bgcolor: 'rgba(79, 70, 229, 0.1)',
          color: '#4F46E5',
          flexShrink: 0
        }}
      >
        {icon}
      </Box>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 600,
          fontSize: '0.875rem',
          color: '#111827'
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default QuickActionButton;